import { useCallback, useEffect, useRef, useState } from 'react';

const HIGHLIGHT_MS = 5000;
const SCROLL_DELAY_MS = 400;

/** Cited chunk numbers as one range when they are contiguous, otherwise as a list. */
const highlightOf = (start, end, chunks) => {
  const last = end || start;
  const cited = chunks?.length ? chunks : Array.from({ length: last - start + 1 }, (_, i) => start + i);
  const contiguous = cited.length > 0 && cited[cited.length - 1] - cited[0] + 1 === cited.length;
  return { first: cited[0], highlight: contiguous ? { start: cited[0], end: cited[cited.length - 1] } : { chunks: cited } };
};

/**
 * Citation markers in the report jump to the cited transcript passage:
 * `onJump` shows the transcript, which scrolls to the passage and highlights it for a few seconds.
 */
export function useCitationJump(onJump) {
  const [highlight, setHighlight] = useState(null);
  const highlightTimer = useRef(null);

  useEffect(() => () => clearTimeout(highlightTimer.current), []);

  const jumpToCitation = useCallback((start, end, chunks) => {
    const target = highlightOf(start, end, chunks);
    setHighlight(target.highlight);
    onJump();
    setTimeout(() => document.getElementById(`ref-${target.first}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }), SCROLL_DELAY_MS);
    clearTimeout(highlightTimer.current);
    highlightTimer.current = setTimeout(() => setHighlight(null), HIGHLIGHT_MS);
  }, [onJump]);

  return { highlight, jumpToCitation };
}
